import React, { Component } from "react";

import AppBar from "@material-ui/core/AppBar";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { Paper, Grid } from "@material-ui/core";
import { Form, Field } from "react-final-form";
import { TextField } from "final-form-material-ui";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { initAuthRequest, resetPasswordRequest } from "../actions";
import { styled, withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import MySnackbar from "./MySnackbar";
import queryString from "query-string";

const styles = theme => ({
  root: {
    flexGrow: 1,
    maxWidth: 600,
    margin: "0 auto"
  },
  link: {
    textDecoration: "none",
    color: "white"
  },
  title: {
    flexGrow: 1
  },
  snackbarcontent: {
    backgroundColor: theme.palette.error.dark
  }
});

const MyGridItem = styled(Grid)({
  minHeight: 84
});

const validate = values => {
  const errors = {};
  if (!values.username) {
    errors.username = "Required";
  }
  if (!values.password) {
    errors.password = "Required";
  }
  return errors;
};

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.message = null;
    localStorage.removeItem("user");
  }

  handleSubmit = values => {
    console.log("Form was submitted." + JSON.stringify(values));
    this.props.initAuthRequest(values.username, values.password);
  };

  handleForgot = values => {
    console.log(
      "Requested forgot password sequence: " + JSON.stringify(values)
    );
  };

  render() {
    const classes = this.props.classes;
    this.message = this.props.error;
    let openSnackbar = this.message ? true : false;
    const parsed = queryString.parse(this.props.location.search);
    console.log("Parsed is " + JSON.stringify(parsed));
    if (parsed.verified && parsed.verified === "false") {
      openSnackbar = true;
      this.message =
        "We were not able to verify your registration using this code.";
    }
    return (
      <div className={classes.root}>
        <AppBar title="Home" position="static">
          <Toolbar>
            <IconButton
              aria-controls="simple-menu"
              aria-haspopup="true"
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="Menu"
            >
              <a href="https://www.openempi.org" className={classes.link}>
                <MenuIcon />
              </a>
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              OpenEMPI Downloads
            </Typography>
          </Toolbar>
        </AppBar>
        <Form
          onSubmit={this.handleSubmit}
          initialValues={{}}
          validate={validate}
          render={({ handleSubmit, form, submitting, pristine, values }) => (
            <div>
              <form onSubmit={handleSubmit} noValidate>
                <Paper style={{ padding: 16 }}>
                  <Grid
                    container
                    alignItems="center"
                    justify="center"
                    direction="row"
                    spacing={2}
                  >
                    <MyGridItem item xs={9}>
                      <Field
                        fullWidth
                        required
                        name="username"
                        component={TextField}
                        type="email"
                        label="Email"
                      />
                    </MyGridItem>
                    <MyGridItem item xs={9}>
                      <Field
                        fullWidth
                        required
                        name="password"
                        component={TextField}
                        type="password"
                        label="Password"
                      />
                    </MyGridItem>
                    <Grid item xs={12}>
                      <Grid container justify="center" spacing={3}>
                        <Grid item>
                          <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            disabled={submitting}
                          >
                            Sign In
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            disabled={submitting}
                          >
                            <Link to="/registration" className={classes.link}>
                              Register
                            </Link>
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            disabled={submitting}
                          >
                            <Link to="/forgot" className={classes.link}>
                              Forgot Password
                            </Link>
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </form>
            </div>
          )}
        />
        <MySnackbar message={this.message} open={openSnackbar} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { error, resetAccount } = state.authentication;
  console.log(state.authentication);
  return {
    resetAccount,
    error
  };
}

export default connect(
  mapStateToProps,
  { initAuthRequest, resetPasswordRequest }
)(withStyles(styles)(LoginForm));
